import { css } from '@mui/material/styles';
import { colors } from './colors.js';

css `
  ::before {
    content: '';
    position: absolute;
    top: -3px;
    right: -3px;
    bottom: -3px;
    left: -3px;
    border: 4px solid ${colors.web.hover};
    border-radius: 9px;
  }
`;
const greenBorder = css `
  border: 4px solid ${colors.web.hover};
`;
const redBorder = css `
  border: 2px solid ${colors.accent.foreground.error};
`;

export { greenBorder, redBorder };
//# sourceMappingURL=sharedCss.js.map
